import { Type } from "@scalar/typebox";
const FeaturesSchema = Type.Partial(
  Type.Object({
    showSidebar: Type.Boolean(),
    showModels: Type.Boolean(),
    showDownload: Type.Boolean(),
    showTestRequestButton: Type.Boolean(),
    showSearch: Type.Boolean(),
    showApiClientImport: Type.Boolean(),
    showDarkModeToggle: Type.Boolean(),
    expandAllTagSections: Type.Boolean(),
    persistAuthenticationState: Type.Boolean()
  })
);
const defaultFeatures = {
  showSidebar: true,
  showModels: true,
  showDownload: true,
  showTestRequestButton: true,
  showSearch: true,
  showApiClientImport: true,
  showDarkModeToggle: true,
  expandAllTagSections: false,
  persistAuthenticationState: false
};
export {
  FeaturesSchema,
  defaultFeatures
};
//# sourceMappingURL=features.js.map
